module.exports = __webpack_public_path__ + "media/images/applestore-logo-4eecce7a.png";